// extracted by mini-css-extract-plugin
export default {"modal_title":"Modal_modal_title__8AMcC","modal_body":"Modal_modal_body__e5ygO","modal_body_image":"Modal_modal_body_image__SidJ5","modal_footer":"Modal_modal_footer__nl4nF"};